export const BREAKPOINT_RESERVATION_PAGE = "900px";
